<span class="hyperion-status-indicator" aria-hidden="true"></span>
<span [class]="labelClasses()">{{ label() }}</span>
